// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/document-schema',
  type: 'object',
  required: ['id', 'creatorId', 'contentLength'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    externalId: {
      type: 'string',
      nullable: true,
    },
    fileName: {
      type: 'string',
      nullable: true,
    },
    filePath: {
      type: 'string',
      nullable: true,
    },
    fileExtension: {
      type: 'string',
      nullable: true,
    },
    contentLength: {
      type: 'integer',
    },
    contentType: {
      type: 'string',
      nullable: true,
    },
    originalFileName: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
